import initialState from "../config/initialState";
import {
  GET_USER_DATA,
  GET_USER_DATA_SUCCESS,
  GET_USER_DATA_ERROR,
  UPDATE_USER_SUBSCRIPTIONS,
  UPDATE_USER_SUBSCRIPTIONS_SUCCESS,
  UPDATE_USER_SUBSCRIPTIONS_ERROR,
} from "../constants/actionTypes";

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER_SUBSCRIPTIONS:
    case GET_USER_DATA: {
      return {
        ...state,
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    case GET_USER_DATA_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        data: action.payload,
      };
    }


    case (UPDATE_USER_SUBSCRIPTIONS_SUCCESS): {
      return {
        ...state,
        data: {
          ...state.data,
          subscriptions: action.payload,
        },
      };
    }

    case UPDATE_USER_SUBSCRIPTIONS_ERROR:
    case GET_USER_DATA_ERROR: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js